import React, { useState } from 'react';
import { isArrayWithLength } from '../../helpers';
import { Col } from 'antd';
import { Radio } from 'antd';
import { StyledModalBodyRow, LoadingModalContent, NoModalContent } from '../ModalBody';
import '../../styles/app.css'

const ProcedureRadioGroup = ({ project, procedures: { data, dataLoaded, error }, onSelectProcedure }) => {
  const [selectedProcedure, setSelectedProcedure] = useState(null);

  if (error) {
    return <NoModalContent message='Error loading procedures - close and try again.' />;
  }

  if (project === null) {
    return <NoModalContent message='Select a project to view procedures.' />;
  }

  if (!dataLoaded) {
    return <LoadingModalContent />;
  }

  if (!isArrayWithLength(data)) {
    return <NoModalContent message='No procedures for project.' />;
  }

  const handleRadioChange = (e) => {
    const selectedData = data.find(item => item.procedureIdLegacy === e.target.value);
    setSelectedProcedure(e.target.value);
    onSelectProcedure(selectedData);
  };

  return (
    <StyledModalBodyRow>
      <Col>
        <Radio.Group
          onChange={handleRadioChange}
          value={selectedProcedure}
        >
          <div
            style={{
              marginTop: '-0.8rem',
              marginLeft: '1rem',
              whiteSpace: 'nowrap',
              display: 'flex',
              flexDirection: 'column',
              width: '100%'
            }}
          >
            {data.map((procedure) => (
              <Radio
                key={procedure.procedureIdLegacy}
                className='custom-radio'
                value={procedure.procedureIdLegacy}
                style={{ marginTop: '0.8rem' }}
              >
                <div
                  key={procedure.procedureIdLegacy}
                  style={{ display: 'flex', width: '100%' }}
                >
                  <div style={{ minWidth: '2rem' }}>
                    P-{procedure.procedureAlphaId ?? procedure.procedureNumber}
                  </div>
                  <div
                    style={{
                      whiteSpace: 'nowrap',
                      marginRight: '1rem',
                      display: 'block',
                    }}
                  >
                    {procedure.procedureTitle}
                  </div>
                  <div
                    data-toggle="tooltip"
                    title={procedure.procedureExplanation}
                    style={{
                      whiteSpace: 'nowrap',
                      marginRight: '1rem',
                      display: 'block',
                      width: '290px',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}
                  >
                    {procedure.procedureExplanation}
                  </div>
                </div>
              </Radio>
            ))}
          </div>
        </Radio.Group>
      </Col>
    </StyledModalBodyRow>

  );
};

export default ProcedureRadioGroup;